import React from 'react';
import { useTexture } from '../../../hooks';
import Button from '../../../components/xr/button';
import storyCloseBtnIcon from '../../../assets/images/xr/icons/story-close.png';
import storyEditBtnIcon from '../../../assets/images/xr/icons/story-edit.png';
import storyDeleteBtnIcon from '../../../assets/images/xr/icons/story-delete.png';
import storyAudioBtnOnIcon from '../../../assets/images/xr/icons/story-audio-on.png';
import storyAudioBtnOffIcon from '../../../assets/images/xr/icons/story-audio-off.png';
import { Texture } from 'three';
import { ReactThreeFiber } from 'react-three-fiber';

const getIconFromList = (index: number, list: Texture[]) => list[index];

type TStoryActionsProps = {
  showClose?: boolean;
  showAudio?: boolean;
  showEdit?: boolean;
  showDelete?: boolean;

  audioIconN?: 0 | 1;

  position: ReactThreeFiber.Vector3;

  onClickClose: (e?: any) => void;
  onToggleAudio: (e?: any) => void;
  onClickEdit: (e?: any) => void;
  onClickDelete: (e?: any) => void;
  color?: string
};

const StoryActions = ({
  showClose = true,
  showAudio = false,
  showEdit = false,
  showDelete = false,

  audioIconN = 0,

  position,

  onClickClose,
  onToggleAudio,
  onClickEdit,
  onClickDelete,
  color
}: TStoryActionsProps) => {
  const { texture: btnStoryCloseTxt } = useTexture(storyCloseBtnIcon);
  const { texture: btnStoryEditTxt } = useTexture(storyEditBtnIcon);
  const { texture: btnStoryDeleteTxt } = useTexture(storyDeleteBtnIcon);
  const { texture: btnStoryAudioOnTxt } = useTexture(storyAudioBtnOnIcon);
  const { texture: btnStoryAudioOffTxt } = useTexture(storyAudioBtnOffIcon);

  const actions = [];
  const size = 0.035;
  const btnWidth = size * 2; // only if btn geometry is circle
  const spaceSize = 0.01;

  if (showDelete) {
    actions.push({
      key: 'delete',
      template: (
        <Button
          onClick={onClickDelete}
          defaultState={{
            main: { geometry: 'circle', size, material: { transparent: true, opacity: 0.8, color: color || '#40A9E5' } },
            icon: { size: 0.03, material: { transparent: true, map: btnStoryDeleteTxt } },
          }}
        />
      ),
    });
  }

  if (showEdit) {
    actions.push({
      key: 'edit',
      template: (
        <Button
          onClick={onClickEdit}
          defaultState={{
            main: { geometry: 'circle', size, material: { transparent: true, opacity: 0.8, color: color || '#40A9E5' } },
            icon: { size: 0.03, material: { transparent: true, map: btnStoryEditTxt } },
          }}
        />
      ),
    });
  }

  if (showAudio) {
    actions.push({
      key: 'audio',
      template: (
        <Button
          onClick={onToggleAudio}
          defaultState={{
            main: { geometry: 'circle', size, material: { transparent: true, opacity: 0.8, color: color || '#40A9E5' } },
            icon: {
              size: 0.03,
              material: {
                transparent: true,
                map: getIconFromList(audioIconN, [btnStoryAudioOffTxt, btnStoryAudioOnTxt]),
              },
            },
          }}
        />
      ),
    });
  }

  if (showClose) {
    actions.push({
      key: 'close',
      template: (
        <Button
          onClick={onClickClose}
          defaultState={{
            main: { geometry: 'circle', size, material: { transparent: true, opacity: 0.8, color: color || '#40A9E5' } },
            icon: { size: 0.03, material: { transparent: true, map: btnStoryCloseTxt } },
          }}
        />
      ),
    });
  }
  const width = btnWidth * actions.length + (actions.length - 1) * spaceSize;

  return (
    <group position={position} scale={[0.8, 0.8, 0.8]}>
      <group position={[size - width / 2, 0, 0]}>
        {actions.map((act, i) => {
          const x = btnWidth * i + spaceSize * i;

          return (
            <group position={[x, 0, 0]} key={act.key}>
              {act.template}
            </group>
          );
        })}
      </group>
    </group>
  );
};

export default StoryActions;
